import { useEffect } from "react";

const useDocumentTitle = (title) => {

    useEffect(() => {
        document.title = `${title} - Nawatech MVD`;
    }, [title]);

    return null;
}

export default useDocumentTitle;